/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ClipboardCheckIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABOElEQVR4nO2TvU7DMBCAs8BD5BmAoYBgY2MhvrsMyR19gLwCvEEr2qei4iFgYQEJGomFpQgk0IW4rWRDfhEDWDrJcu6+z77YQfBnRkR8bEhuNXTeLzxO9w3KM5C8a+hc1zqDDcmVhX4ZyLNasCzLNoBkYlCu7VolvIxlPvKNQblQliMA4umyCCQsC2ZVcENyWeSChGvrE7cdyI+rHvNZ03YC8flKwA+ehLVdobyoxJ7kWzBIqLla42ubV9BHBP8CQJkDyF5Ep0ddWrQAklf3ccn8JE63itsXp4dtBQu9IVGcDord+uBGdoA4byUwKG8K12+Iw+1CUhPeoEWcK8hK6sIbXlN+Ihru2rw68BbvgHMAOfj8odXw33lohvi+R8Gd7wTjvgQGZeQIkiTZVEmXk5S1Y2U5gp8aH8ixgWxGani2AAAAAElFTkSuQmCC)
 */
export const ClipboardCheckIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M5 5.5c0-.28-.23-.5-.5-.46A3 3 0 0 0 2 8v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V8a3 3 0 0 0-2.5-2.96c-.27-.04-.5.18-.5.46V6a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-.5Zm11.7 6.8a1 1 0 0 1 0 1.4l-5 5a1 1 0 0 1-1.4 0l-3-3a1 1 0 1 1 1.4-1.4l2.3 2.29 4.3-4.3a1 1 0 0 1 1.4 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M17 5.5V6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h1c.55 0 .98-.47 1.24-.96a2 2 0 0 1 3.52 0c.26.49.69.96 1.24.96h1a1 1 0 0 1 1 1v.5Z"
        className={colorClass}
      />
    </svg>
  );
};
